export default __webpack_public_path__ + "static/media/maintenance.14a6d67c.gif";